import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartDonut from '../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../components/charts/types/ChartColumn'
import { formatNumber, formatDateCard } from '../../../utils/Helpers'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import { GET_BRANDS } from '../../../queries/factory'

interface Bucket {
  key: string
  doc_count: number
}
const TransactionsByBrand = (): JSX.Element => {
  const { filters } = useContext(FactoryFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_BRANDS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartDonutSkeleton />
  if (loading || !data) return <ChartDonutSkeleton />
  if (error) return <p>Error :(</p>
  if (!data?.aggregation?.aggregations) return <p>No data found</p>

  const labels: Array<string> = []
  const series: Array<number> = []

  data?.aggregation?.aggregations?.brands?.buckets.map((bucket: Bucket) => {
    labels.push(bucket.key)
    series.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'cancelation-reasons'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        let total = 0
        opts.w.globals.series.map((serie: any) => {
          total += serie
        })

        return [seriesName, ' - ', formatNumber((opts.w.globals.series[opts.seriesIndex] / total) * 100, 2), '%']
      },
      width: 220,
      height: 300
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 0
        },
        spokes: {
          strokeWidth: 0
        }
      }
    }
  }

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>TOP 10 Transações por marca ({formatDateCard(filters.orderCreatedAt?.initialDate, filters.orderCreatedAt?.finalDate)})</Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.rainbow} type="polarArea" />
  </Paper>
}

export default TransactionsByBrand
